import { useTranslate } from '@refinedev/core';
import { Form, Checkbox, Space, Tag, Typography } from 'antd';
import { LabelKind } from '@/api/generated/schemas';

const { Text } = Typography;

interface LabelsFieldProps {
  disabled?: boolean;
}

/** Form control for the `labels` field — a checkbox group of LabelKind values. */
export const LabelsField = ({ disabled }: LabelsFieldProps) => {
  const t = useTranslate();

  return (
    <Form.Item name="labels" label={t('base.labels._field')}>
      <Checkbox.Group
        disabled={disabled}
        options={Object.values(LabelKind).map((value) => ({
          label: t(`base.labels.${value}`),
          value,
        }))}
      />
    </Form.Item>
  );
};

interface LabelsTagsProps {
  labels?: LabelKind[] | null;
}

/** Read-only render of a list of labels as tags. */
export const LabelsTags = ({ labels }: LabelsTagsProps) => {
  const t = useTranslate();

  if (!labels || labels.length === 0) {
    return <Text type="secondary">-</Text>;
  }

  return (
    <Space wrap>
      {labels.map((label) => (
        <Tag key={label}>{t(`base.labels.${label}`)}</Tag>
      ))}
    </Space>
  );
};
